import { useLocation } from 'react-router-dom';
import { Button } from '../ui/Button';
import { MenuAcciones } from '../ui/MenuAcciones';
import { useTemaStore } from '../../stores/temaStore';
import { useAvisoSonoroStore } from '../../stores/avisoSonoroStore';
import { useOcultarDemo } from '../../hooks/useOcultarDemo';
import estilos from './AccionesRapidas.module.css';

/**
 * Los tres conmutadores de siempre —tema, sonido de alarmas y ocultar Demo—
 * junto al título de cada pantalla.
 *
 * Van en la cabecera y no en la barra lateral porque son ajustes que se tocan
 * a menudo y desde cualquier sitio; en la barra ocupaban tres filas enteras.
 *
 * En pantalla ancha son tres iconos sueltos. En el móvil se recogen tras uno
 * solo, pegado al borde derecho: tres iconos más los botones de la pantalla no
 * caben en una línea, y partirlos en dos filas gasta alto que necesitan los
 * datos.
 *
 * El disparador lleva el icono de ajustes y no el de menú a propósito: la barra
 * superior ya tiene un menú de tres rayas para la navegación, y repetir el
 * mismo icono a un palmo de distancia para otra cosa distinta se presta a
 * confusión. Si lo prefieres igual que el otro, es cambiar una palabra.
 */
export function AccionesRapidas() {
  const { tema, alternar } = useTemaStore();
  const avisoActivo = useAvisoSonoroStore((s) => s.activo);
  const alternarAviso = useAvisoSonoroStore((s) => s.alternar);
  const demo = useOcultarDemo();

  /*
   * El texto sólo en el Panel. Es la pantalla de entrada y donde alguien ve
   * estos tres botones por primera vez, así que ahí conviene que digan qué
   * hacen. En el resto ya se conocen y el texto compite con los filtros y las
   * acciones propias de cada pantalla.
   */
  const esPanel = useLocation().pathname === '/';

  const etiquetaTema = tema === 'oscuro' ? 'Tema claro' : 'Tema oscuro';
  const etiquetaAviso = avisoActivo ? 'Silenciar alarmas' : 'Volver a oír las alarmas';
  const etiquetaDemo = demo.ocultando ? 'Mostrar cliente de muestra' : 'Ocultar cliente de muestra';

  return (
    <MenuAcciones
      soloEnMovil
      textoSoloEnMenu={!esPanel}
      icono="ajustes"
      etiqueta="Preferencias de la vista"
      className={estilos.grupo}
    >
      <Button
        variante="fantasma"
        tamano="sm"
        compactoEnMovil
        icono={tema === 'oscuro' ? 'temaClaro' : 'temaOscuro'}
        onClick={alternar}
        title={etiquetaTema}
      >
        {etiquetaTema}
      </Button>

      <Button
        variante="fantasma"
        tamano="sm"
        compactoEnMovil
        icono={avisoActivo ? 'sonidoActivo' : 'sonidoMudo'}
        onClick={alternarAviso}
        title={etiquetaAviso}
        aria-pressed={avisoActivo}
      >
        {etiquetaAviso}
      </Button>

      {demo.disponible && (
        <Button
          variante="fantasma"
          tamano="sm"
          compactoEnMovil
          icono={demo.ocultando ? 'ver' : 'ocultar'}
          onClick={demo.alternar}
          title={etiquetaDemo}
          aria-pressed={demo.ocultando}
        >
          {etiquetaDemo}
        </Button>
      )}
    </MenuAcciones>
  );
}
